export default __webpack_public_path__ + "static/media/clear.9a161aee.mp3";